var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/account/viewmodels/login',["require", "exports", "models/portal", "durandal/app", "plugins/dialog", "models/account", "common/string", "common/viewmodelbase", "services/trace", "services/settings", "services/httpclient", "areas/home/commands/logoutcommand", "plugins/router"], function (require, exports, Portal, app, dialog, Account, Strings, vm, trace, configuration, http, LogoutCommand, Router) {
    "use strict";
    var LoginViewModel = (function (_super) {
        __extends(LoginViewModel, _super);
        // Usermanagement-End
        function LoginViewModel() {
            _super.call(this);
            this.isDialog = false;
            this.isAuthenticating = false;
            this.clientNumber = "";
            this.username = "";
            this.password = "";
            this.keepSignedIn = false;
            this.shouldChangePassword = false;
            this.validEmail = false;
            this.shouldInputEmail = false;
            this.shouldConfirmEmail = false;
            this.showClientNumber = true;
            this.isClient = false;
            // Usermanagement-Start
            this.router = Router;
            this.logoutCommand = new LogoutCommand(this.router, Portal.Context.shell.userManager, this.applications);
            this.hiddenFlagEmail = "hidden";
            this.userEmail = "xxx@yyy.de";
            this.userPassword = "";
            this.userPasswordState = 0;
            this.userPasswordRepetition = "";
            this._hash = null;
            this.title = "Login";
            this.isDialog = dialog.getDialog(this) != null;
            ko.track(this, ["isAuthenticating", "clientNumber", "username", "password", "keepSignedIn", "shouldChangePassword", "shouldInputEmail", "shouldConfirmEmail", "userEmail", "userPasswordRepetition", "userPassword", "passwordRulesMessage"]);
        }
        LoginViewModel.prototype.onActivated = function (context) {
            var _this = this;
            document.addEventListener("keydown", this.disableF5);
            var input = context.queryString;
            if (input != null) {
                this._hash = input.reqinput;
                if (this._hash.trim().length > 10) {
                    // needed for passwordchangerequest
                    if (input.state == '1' || input.state == '2') {
                        this.confirmOrAbuseEmail(input.reqinput, input.state);
                    }
                }
            }
            // direkte eingaben
            var search = window.location.search;
            var parameters = search.split("&");
            Enumerable.From(parameters).ForEach(function (x) {
                if (Strings.contains(x, "no=")) {
                    _this.clientNumber = x.split("=")[1];
                }
                if (Strings.contains(x, "user=")) {
                    _this.username = x.split("=")[1];
                }
                if (Strings.contains(x, "pass=")) {
                    _this.password = x.split("=")[1];
                }
            });
        };
        LoginViewModel.prototype.isValid = function () {
            var isValid = this.username && this.password;
            if (!isValid) {
                var messageEnterAccountData = $.t("app:modules.account.message_enterAccountData", { ifMissing: "Bitte geben Sie mindestens Benutzername und Kennwort ein." });
                trace.traceInformation(messageEnterAccountData);
            }
            return isValid;
        };
        LoginViewModel.prototype.isValidPasswordRepetition = function () {
            var isValid = this.userPassword == this.userPasswordRepetition && this.userPassword !== "";
            this.hiddenFlagEmail = "hidden";
            //// first regex check
            //var regex: string = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{10,}$';
            //var regexp = new RegExp(regex);
            //isValid = regexp.test(this.userPassword);
            // than confirmation-check
            if (isValid) {
                isValid = this.userPassword == this.userPasswordRepetition;
                this.hiddenFlagEmail = "";
            }
            return isValid;
        };
        LoginViewModel.prototype.cancel = function () {
            app.trigger("authentication", Account.Session.isAuthenticated);
            dialog.close(this); // falls als Dialog gestartet.
        };
        LoginViewModel.prototype.login = function () {
            var _this = this;
            var that = this;
            if (!this.isValid())
                return null;
            that.isAuthenticating = true;
            var request = new Account.Requests.LoginRequest(configuration.Settings.getPortalDomain(), this.username, this.password, this.clientNumber, this.keepSignedIn);
            return Portal.Context.shell.userManager.signIn(request)
                .then(function (data) {
                that.isAuthenticating = false;
                that.isClient = Account.Principal.current.memberType.toLowerCase() === 'client_postmaster';
                that.shouldChangePassword = !(Strings.contains(window.location.search, "nid=")) && Account.Principal.current.shouldChangePassword;
                that.shouldInputEmail = Strings.isNullOrEmpty(Account.Principal.current.email);
                that.userEmail = Account.Principal.current.email;
                that.shouldConfirmEmail = Account.Principal.current.shouldConfirmEmail;
                //that.shouldChangePassword = true;
                if (!that.shouldChangePassword && !that.shouldInputEmail && !that.shouldConfirmEmail) {
                    app.trigger("authentication", Account.Session.isAuthenticated);
                    dialog.close(_this); // falls als Dialog gestartet.
                    document.removeEventListener("keydown", _this.disableF5);
                }
                else {
                }
                if (that.shouldChangePassword) {
                    if (that.isClient) {
                        var resetPasswordUrl = configuration.Settings.environment.getCustomValue("ClientResetPasswordPage").replace('{0}', configuration.Settings.getPortalDomain());
                        window.location.href = resetPasswordUrl + jQuery.base64.encode(Account.Session.getSessionId(), true);
                    }
                    else {
                        that.getPasswordRulesMessage();
                    }
                }
            })
                .fail(function (reason) {
                var messageLoginError = $.t("app:modules.account.message_loginError", { ifMissing: "Es ist ein Fehler bei der Anmeldung aufgetreten. Bitte prüfen Sie Ihre Zugangsdaten." });
                var messageLogin = $.t("app:modules.account.message_login", { ifMissing: "Anmeldung" });
                trace.traceError(reason, null, messageLogin, true);
                that.isAuthenticating = false;
            });
        };
        LoginViewModel.prototype.resetPassword = function () {
            if (!(this.username.trim().length > 0)) {
                var messageResetPasswordEmptyUsernameError = $.t("app:modules.account.message_resetPasswordEmptyUsernameError", { ifMissing: "Bitte geben Sie die E-Mail ein, um Ihr Kennwort zu ändern." });
                var messageLogin = $.t("app:modules.account.message_login", { ifMissing: "Anmeldung" });
                trace.traceError(messageResetPasswordEmptyUsernameError, null, messageLogin, true);
                return;
            }
            var request = new Account.Requests.LoginRequest(configuration.Settings.getPortalDomain(), this.username, "", this.clientNumber);
            return Portal.Context.shell.userManager.resetPassword(request)
                .then(function (data) {
                alert(data);
            })
                .fail(function (result) {
                var messageResetPasswordError = $.t("app:modules.account.message_resetPasswordError", { ifMissing: "Es ist ein Fehler bei der Anmeldung aufgetreten. Bitte prüfen Sie Ihre Zugangsdaten." });
                var messageLogin = $.t("app:modules.account.message_login", { ifMissing: "Anmeldung" });
                trace.traceError(messageResetPasswordError + result.responseText, null, messageLogin, true);
            });
        };
        LoginViewModel.prototype.saveCredentials = function () {
            var _this = this;
            var service = new http.Channel();
            var that = this;
            // Update Email
            if ((that.shouldInputEmail || that.shouldConfirmEmail)) {
                service.putData("/api/account/me/mail?portalUserId=" + Account.Principal.current.id + "&email=" + that.userEmail, http.ServiceTarget.portalApi, null).
                    then(function (data) {
                    var messageUpdateEmailSuccess = $.t("app:modules.account.message_updateEmailSuccess", { ifMissing: 'Ihre E-Mail Adresse wurde erfolgreich aktualisiert. Wenn Sie sich per E-Mail über neue Eingänge informieren lassen möchten, wählen Sie die entsprechende Option in der App "Benutzereinstellungen".' });
                    trace.trace(messageUpdateEmailSuccess, null, "msg:index", true);
                    app.trigger("authentication", Account.Session.isAuthenticated);
                    dialog.close(_this); // falls als Dialog gestartet.
                    document.removeEventListener("keydown", _this.disableF5);
                }).fail(function (exception) {
                    trace.traceError(exception.responseJSON.Message, null, "usermangement", true);
                });
            }
            ;
            // Update Password
            if (that.shouldChangePassword) {
                var request = new Account.Model.Password(this.userPassword, this.userPasswordRepetition);
                var userManager = Portal.Context.shell.userManager;
                var instance = this._hash != null ? userManager.changePassword(Account.Principal.current.id, this._hash, request) : userManager.setPasswordFor(Account.Principal.current.identityId, Account.Principal.current.id, request);
                instance.
                    then(function (data) {
                    var messageUpdatePasswordSuccess = $.t("app:modules.account.message_updatePasswordSuccess", { ifMissing: 'Ihr Kennwort wurde erfolgreich aktualisiert.' });
                    trace.trace(messageUpdatePasswordSuccess, null, "msg:index", true);
                    app.trigger("authentication", Account.Session.isAuthenticated);
                    dialog.close(_this); // falls als Dialog gestartet.
                    document.removeEventListener("keydown", _this.disableF5);
                }).fail(function (exception) {
                    var messageUpdatePasswordError = $.t("app:modules.account.message_updatePasswordError", { ifMissing: "Fehler bei der Kennwortaktualisierung: " });
                    trace.traceError(messageUpdatePasswordError + exception.responseText, null, "usermangement", true);
                });
            }
            ;
        };
        LoginViewModel.prototype.savePasswordOnly = function () {
            var _this = this;
            var service = new http.Channel();
            var that = this;
            // Update Password
            if (that.shouldChangePassword) {
                var request = new Account.Model.Password(this.userPassword, this.userPasswordRepetition);
                var userManager = Portal.Context.shell.userManager;
                var instance = this._hash != null ? userManager.changePassword(Account.Principal.current.id, this._hash, request) : userManager.setPasswordFor(Account.Principal.current.identityId, Account.Principal.current.id, request);
                instance.
                    then(function (data) {
                    var messageUpdatePasswordSuccess = $.t("app:modules.account.message_updatePasswordSuccess", { ifMissing: 'Ihr Kennwort wurde erfolgreich aktualisiert.' });
                    trace.trace(messageUpdatePasswordSuccess, null, "msg:index", true);
                    app.trigger("authentication", Account.Session.isAuthenticated);
                    dialog.close(_this); // falls als Dialog gestartet.
                    document.removeEventListener("keydown", _this.disableF5);
                }).fail(function (exception) {
                    var messageUpdatePasswordError = $.t("app:modules.account.message_updatePasswordError", { ifMissing: "Fehler bei der Kennwortaktualisierung: " });
                    trace.traceError(messageUpdatePasswordError + exception.responseJSON.Message, null, "usermangement", true);
                });
            }
            ;
        };
        LoginViewModel.prototype.confirmOrAbuseEmail = function (hash, state) {
            var _this = this;
            var service = new http.Channel();
            var that = this;
            that.userPasswordState = state;
            service.putData("/api/account/me/confirmemail?requestHash=" + hash + "&state=" + state, http.ServiceTarget.portalApi, null).
                then(function (data) {
                if (that.userPasswordState == 1) {
                    var messageEmailConfirmation = $.t("app:modules.account.message_eMailConfirmation", { ifMissing: 'Ihre E-Mail-Adresse wurde bestätigt. Wenn Sie sich per E-Mail über neue Eingänge informieren lassen möchten, wählen Sie die entsprechende Option in der App Benachrichtigungen.' });
                    trace.trace(messageEmailConfirmation, null, "msg:index", true);
                    _this.logoutCommand.execute(_this);
                }
                if (that.userPasswordState == 2) {
                    var messageEmailAbuse = $.t("app:modules.account.message_eMailAbuse", { ifMissing: "Ihre E-Mail wurde erfolgreich deaktiviert. Um eine neue E-Mail-Adresse zu hinterlegen, melden Sie sich bitte mit Ihren Zugangsdaten an und erfassen Sie nachfolgend die entsprechende E-Mail-Adresse." });
                    trace.trace(messageEmailAbuse, null, "msg:index", true);
                    _this.logoutCommand.execute(_this);
                }
                if (that.userPasswordState == 0 || that.userPasswordState > 2) {
                    var messageInvalidEmailState = $.t("app:modules.account.message_invalidEmailState", { ifMissing: "Ungültiger Password-Status" });
                    trace.traceError(messageInvalidEmailState, null, "msg:index", true);
                    _this.logoutCommand.execute(_this);
                }
            }).fail(function (exception) {
                var messageEmailConfirmError = $.t("app:modules.account.message_eMailConfirmError", { ifMissing: "Fehler bei der E-Mail Bestätigung" });
                trace.traceError(messageEmailConfirmError + exception.responseJSON.Message, null, "usermangement", true);
            });
        };
        LoginViewModel.prototype.getPasswordRulesMessage = function () {
            var self = this;
            var organizationId = Account.Principal.current.organizationId;
            var channel = new http.Channel();
            var result = channel.getData("/api/network/organizations/" + organizationId + "/passwordrule/message", http.ServiceTarget.publicApi)
                .then(function (message) {
                self.passwordRulesMessage = message;
            })
                .fail(function (reason) {
                var getPasswordRulesErrorMessage = $.t("app:modules.account.message_passwordRulesMessageError", { ifMissing: "Fehler beim Laden der Password-Regel" });
                trace.traceError(getPasswordRulesErrorMessage, null, "usermangement", true);
            });
        };
        LoginViewModel.prototype.readExceptionMessage = function (reason) {
            try {
                var message = reason.responseJSON.Message;
                return message;
            }
            catch (exception) {
                return JSON.stringify(reason);
            }
        };
        LoginViewModel.prototype.guardChangedPassword = function () {
            //var showChangePasswordDialog = !(Strings.contains(window.location.search, "nid=")) && Account.Principal.current.shouldChangePassword;
            //if (showChangePasswordDialog) {
            //	App.showDialog("areas/account/viewmodels/changePassword", Account.Principal.current.id);
            //}
        };
        LoginViewModel.prototype.disableF5 = function (e) {
            if ((e.which || e.keyCode) == 116)
                e.preventDefault();
        };
        ;
        return LoginViewModel;
    }(vm.ViewModelBase));
    return LoginViewModel;
});

